const swiper_thumbs = new Swiper('.swiper-thumbs', {
    slidesPerView: 4,
    spaceBetween: 12,
    loop: false,
    lazy: true,
    centeredSlides: false,
});

const swiper = new Swiper('.swiper', {
    // Optional parameters
    loop: false,
    lazy: true,
    lazyPreloadPrevNext: false,

    // Navigation arrows
    navigation: {
        nextEl: '.carousel-button-next',
        prevEl: '.carousel-button-prev',
    },

    thumbs: {
        swiper: swiper_thumbs,
    },
});

document.querySelectorAll(".swiper-cart").forEach((ele) => {
    const swiperCart = new Swiper('.swiper-cart', {
        // Optional parameters
        loop: true,
        slidesPerView: 1,
        spaceBetween: 16,
        navigation: {
            nextEl: '.swipercart-button-next',
            prevEl: '.swipercart-button-prev',
        },
        // Responsive breakpoints
        breakpoints: {
            // when window width is <= 499px
            768: {
                slidesPerView: 2,
                spaceBetweenSlides: 8,
            },
            1024: {
                slidesPerView: 4,
                spaceBetweenSlides: 16,
            }
        }
    });
});

document.querySelectorAll(".swiper-product").forEach((ele) => {
    const swiperProduct = new Swiper(ele, {
        slidesPerView: "auto",
        loop: true,
        lazy: true,
        navigation: {
            nextEl: '.carousel-button-next',
            prevEl: '.carousel-button-prev'
        },
        pagination: {
            el: ".swiper-pagination",
        },
    }); 
})
